import { useTranslation } from 'react-i18next';
import { memo, useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { styled } from 'styled-components';
import { showForestWatchPanelAtom } from '~/components/Map/stores/mapStore';
import { UI_Header, UI_HeaderLeft, UI_HeaderLeft_TabHeader, UI_HeaderRight, UI_HeaderRight_item } from '../PanelStyle';
import { FaXmark } from 'react-icons/fa6';
import { PiPlanetBold, PiFlameBold } from 'react-icons/pi';
import SatelliteTab from './SatelliteImageTab/SatelliteImageTab';
import WildfiresTab from './WildfiresTab/WildfiresTab';
import { Rnd } from 'react-rnd';

interface ForestWatchPanelProps {
}

enum TabEnum {
  SATELLITE = 'SATELLITE',
  WILDFIRES = 'WILDFIRES',
}

const ForestWatchPanel = (props: ForestWatchPanelProps) => {
  const { t } = useTranslation();

  const [currentTab, setCurrentTab] = useState<TabEnum>(TabEnum.SATELLITE);
  const [showForestWatchPanel, setShowForestWatchPanel] = useAtom<boolean>(showForestWatchPanelAtom);

  return (
    <Rnd
      default={{
        x: 8,
        y: 32,
        width: 300,
        height: 500,
      }}
      minWidth={280}
      minHeight={250}
      dragHandleClassName="draggable-header"
      cancel=".no-drag, .no-drag *, button, input, textarea, select, a"
      bounds="window"
      enableResizing={{
        bottom: true,
        bottomRight: true,
        right: true,
        top: false,
        topLeft: false,
        topRight: false,
        left: false,
        bottomLeft: false,
      }}
      style={{ zIndex: 900 }}
    >
      <UI_Wrapper>
        <UI_Header className="draggable-header" style={{ cursor: 'move', userSelect: 'none' }}>
          <UI_HeaderLeft className="no-drag" style={{ cursor: 'default' }}>
            <UI_HeaderLeft_TabHeader onClick={() => setCurrentTab(TabEnum.SATELLITE)} className={currentTab === TabEnum.SATELLITE ? 'active' : ''}>
              <PiPlanetBold style={{ fontSize: '15px' }} />
              <span>Ảnh vệ tinh</span>
            </UI_HeaderLeft_TabHeader>
            <UI_HeaderLeft_TabHeader onClick={() => setCurrentTab(TabEnum.WILDFIRES)} className={currentTab === TabEnum.WILDFIRES ? 'active' : ''}>
              <PiFlameBold style={{ fontSize: '15px', color: '#ef4444' }} />
              <span>Cháy rừng</span>
            </UI_HeaderLeft_TabHeader>
          </UI_HeaderLeft>
          <UI_HeaderCenter style={{ flex: 1, height: '100%' }} />
          <UI_HeaderRight className="no-drag" style={{ cursor: 'default' }}>
            {/* <UI_HeaderRight_item onClick={() => setshowCommentOnMap(!showCommentOnMap)}>
              {showCommentOnMap ? <FaEye /> : <FaEyeSlash />}
            </UI_HeaderRight_item> */}
            {/* <UI_HeaderRight_item>
              <IoEllipsisHorizontal />
            </UI_HeaderRight_item> */}
            <UI_HeaderRight_item onClick={() => {
              setShowForestWatchPanel(false);
            }}>
              <FaXmark />
            </UI_HeaderRight_item>
          </UI_HeaderRight>
        </UI_Header>

        <UI_Content>
          {
            currentTab === TabEnum.SATELLITE && (
              <SatelliteTab />
            )
          }
          {
            currentTab === TabEnum.WILDFIRES && (
              <WildfiresTab />
            )
          }
        </UI_Content>
      </UI_Wrapper>
    </Rnd>
  );
};

export default memo(ForestWatchPanel);

const UI_Wrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  background-color: #fff;
  border-right: 1px solid #ccc;
  background-color: rgba(255,255,255, 0.8);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadows-paneShadow);
  overflow: hidden;
`;

const UI_HeaderCenter = styled.div`
  flex: 1;
  height: 100%;
`;

const UI_Content = styled.div`
  padding: 0px 8px;
  flex: 1;
  overflow-y: auto;
`;